import { NetworkStatus } from '@apollo/client';

export const isFetchingMore = (networkStatus: NetworkStatus): boolean =>
  networkStatus === NetworkStatus.fetchMore;

export const isLoading = (networkStatus: NetworkStatus): boolean =>
  networkStatus === NetworkStatus.loading;

export const isSettingVariables = (networkStatus: NetworkStatus): boolean =>
  networkStatus === NetworkStatus.setVariables;

export const isRefetching = (networkStatus: NetworkStatus): boolean =>
  networkStatus === NetworkStatus.refetch;
